/* ARIELLE v15: category carousel navigation. No dependencies. */
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-ar-v15-scroll]');
  if (!button) return;
  var section = button.closest('.ar-v15-cats');
  var track = section && section.querySelector('.ar-v15-cats__track');
  if (!track) return;
  var firstTile = track.querySelector('.ar-v15-cats__tile');
  var amount = firstTile ? firstTile.getBoundingClientRect().width + 12 : 150;
  var direction = Number(button.getAttribute('data-ar-v15-scroll')) || 1;
  track.scrollBy({ left: direction * amount * 3, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});
